export const JOINED_COUNT = '50 000';
